import { combineReducers } from "redux";
import assessmentReducer from "./assessment.reducer";
import errorReducer from "./error.reducer";
import questionsReducer from "./questions.reducer";
import loaderReducer from "./loader.reducer";
import testReducer from "./test.reducer";
import questionanswerReducer from "./questionAnswer.reducer";
import digitalMeReducer from "./digitalMe.reducer";
import notificationReducer from "./notification.reducer";
import reducers from "../../whiteboard-react-konva/src/store/reducers/index.reducer";
import validValuesReducer from "./valid-values.reducer";
import iqReducer from "./iqtest.reducer";
import classFeedReducer from "./classfeed.reducer";
import studentsReducer from "./students.reducer";
import assessmentRollBackReducer from "./assessmentRollback.reducer";
import { uiReducer } from "./ui.reducer";
import knowledgeReducer from "./knowledge.reducer"

const combinedReducer = combineReducers({
  assessmentsReducer: assessmentReducer,
  questionsReducer: questionsReducer,
  errors: errorReducer,
  loader: loaderReducer,
  questionanswer: questionanswerReducer,
  digitalMe: digitalMeReducer,
  iqReducer: iqReducer,
  validValue: validValuesReducer,
  testReducer: testReducer,
  notificationReducer: notificationReducer,
  classFeedReducer: classFeedReducer,
  studentsReducer: studentsReducer,
  assessmentRollBackReducer,
  ui: uiReducer,
  knowledgeReducer,
  ...reducers,
});
export default combinedReducer;
